export default "__VITE_ASSET__4932c4e7__"